import {Node} from '../treeview/node';
export class TreeviewNodeEvent {
    private _event:MouseEvent;
    private _node:Node;

    constructor(val1,val2) {
        this._event = val1;
        this._node = val2;
    }


    getEvent(): MouseEvent {
        return this._event;
    }

    setEvent(value: MouseEvent) {
        this._event = value;
    }

    getNode(): Node {
        return this._node;
    }

    setNode(value: Node) {
        this._node = value;
    }
}
